import React, { Component } from 'react';
import Header from './partials/header'
import Footer from './partials/footer'
import ImageFullScreen from './imageFullScreen'
import SecondPart from './secondPart'
import Formules from './formules'
import Formulaire from './formulaire'
import SidebarFeedBack from './sidebarFeedBack'

class Layout extends Component {

  render() {
    return (
      <div className="Layout">
        <SidebarFeedBack/>
        <Header />
        <ImageFullScreen />
        <SecondPart />
        <Formules />
        <Formulaire />
        <Footer />
      </div>
    )
  }

}


export default Layout;



// WEBPACK FOOTER //
// ./src/client/components/layout.js